import { Box, css, Flex, Icon, Text } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import Image from "next/image";
import Link from "next/link";
import { useQuery } from "react-query";
import { BlogCard } from "~components/common/BlogCard";
import { Star } from "~components/common/Icons";

export const Recipe = ({ content, size }) => {
  const supabase = createClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL,
    process.env.NEXT_PUBLIC_SUPABASE_KEY
  );
  const getRecipe = async (): Promise<any> => {
    try {
      //@ts-ignore
      let { data } = await supabase
        .from("recipes_with_rating")
        .select(
          "*, summary(text), title(text), contents_uom(text), difficulty(text), makes_uom(text)"
        )
        .eq("id", content.id);
      return data[0];
    } catch (err) {
      console.log(err);
    }
  };
  const { data: recipe } = useQuery(["getRecipe", content], () => getRecipe(), {
    enabled: Boolean(content),
  });
  if (recipe)
    return (
      <>
        <Link
          href={`/recipes/${recipe?.slug}`}
          as={`/recipes/${recipe?.slug}`}
          passHref
        >
          <Box
            cursor={"pointer"}
            flexDirection={["column", size === 1 ? "row" : "column"]}
            p={["15px", size === 3 ? "15px" : "25px"]}
            border="1px solid grey200"
            borderRadius={"md"}
            flexWrap="nowrap"
            display={[content.isSmallCard ? "none" : "flex", "flex"]}
          >
            <Box
              mr={[0, size === 1 && "24px"]}
              width={["100%", size === 1 ? "257px" : "100%"]}
              flex="none"
              position="relative"
              height={[
                "216px",
                size === 3 ? "200px" : size === 1 ? "167px" : "300px",
              ]}
              css={css({
                img: {
                  borderRadius: "sm",
                },
              })}
            >
              <Image src={recipe.image} objectFit="cover" layout="fill" />
            </Box>
            <Box mb={"3px"}>
              <Text
                mt={"10px"}
                maxWidth={["300px", size === 3 ? "218px" : "333px"]}
                fontSize={"16px"}
                fontWeight={700}
                lineHeight="20px"
                fontFamily={"DINPro"}
                css={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {recipe?.title?.text.toUpperCase()}
              </Text>
              <Flex mt={"5px"} justifyContent={"space-between"}>
                <Text
                  fontFamily={"DINPro"}
                  fontSize="12px"
                  color="#767473"
                  lineHeight={"13px"}
                  alignItems={"center"}
                  pt="3px"
                >
                  RECEPT
                </Text>
                {!!recipe.rating && (
                  <Flex lineHeight="13px">
                    <Text fontWeight={700} mr="5px" pt="2px">
                      {recipe.rating}
                    </Text>
                    <Icon color={"oldPink"} icon={Star} />
                  </Flex>
                )}
              </Flex>
              {size === 1 && (
                <Text
                  display={["none", "block"]}
                  maxHeight={"75px"}
                  color="#767473"
                  fontSize={"16px"}
                  lineHeight="25px"
                  overflow={"hidden"}
                >
                  {recipe.summary.text.replace(/<\/?[^>]+(>|$)/g, "")}
                </Text>
              )}
            </Box>
          </Box>
        </Link>
        <Box display={["block", "none"]}>
          {content.isSmallCard && <BlogCard content={recipe} />}
        </Box>
      </>
    );
  return null;
};
